import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { HelpFormDto } from '../models/help/HelpFormDto';

export class HelpService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/help');
  }

  public async SubmitForm(formData: HelpFormDto): Promise<RequestResult<any>> {
    return await this.client.postJson('', formData);
  }
}
